import { render, staticRenderFns } from "./Propositions.vue?vue&type=template&id=db07810c&scoped=true&"
import script from "./Propositions.vue?vue&type=script&lang=js&"
export * from "./Propositions.vue?vue&type=script&lang=js&"
import style1 from "./Propositions.vue?vue&type=style&index=1&id=db07810c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db07810c",
  null
  
)

export default component.exports